import { QZ_SIGNING_ENABLED } from '../config_and_helpers/labelPrinterConfig';
import { getQzCertificate, signQzRequest } from '../clients/printing_client';
import { logError, logInfo } from '../config_and_helpers/logger';

const LOG_CONTEXT = 'qzSecurity';

let securityConfigured = false;

/**
 * @param {object} qz
 * @param {string|null} authToken
 */
export const configureQzSecurity = async (qz, authToken = null) => {
  if (securityConfigured) return;
  securityConfigured = true;

  if (QZ_SIGNING_ENABLED && authToken) {
    logInfo(LOG_CONTEXT, 'configure production QZ signing');
    qz.security.setCertificatePromise((resolve, reject) => {
      getQzCertificate(authToken)
        .then(result => {
          if (result.success) resolve(result.data);
          else reject(new Error('Unable to load QZ certificate'));
        })
        .catch(reject);
    });
    qz.security.setSignatureAlgorithm('SHA512');
    qz.security.setSignaturePromise(toSign => (resolve, reject) => {
      signQzRequest(authToken, toSign)
        .then(result => {
          if (result.success) resolve(result.data);
          else reject(new Error('Unable to sign QZ request'));
        })
        .catch(reject);
    });
    return;
  }

  logInfo(LOG_CONTEXT, 'configure development QZ security (unsigned prompts)');
  qz.security.setCertificatePromise(resolve => resolve());
  // Do not setSignaturePromise — rejecting breaks printers.find() on HTTPS prod.
  // QZ shows untrusted-site allow dialogs instead.
};

/** Reset for tests. */
export const resetQzSecurityForTests = () => {
  securityConfigured = false;
};

export const mapQzConnectionError = error => {
  const message = String(error?.message || error || '').toLowerCase();
  if (
    message.includes('unable to connect') ||
    message.includes('connection refused') ||
    message.includes('websocket')
  ) {
    return {
      code: 'QZ_NOT_RUNNING',
      userMessage:
        'Direct printing requires QZ Tray on this computer.\n\nOpen QZ Tray and try again, or use Print Preview.',
    };
  }
  if (message.includes('signing failed') || message.includes('unable to load qz certificate')) {
    return {
      code: 'QZ_SIGNING',
      userMessage:
        'QZ Tray signing is not configured.\n\nEnsure backend /printing/qz-* is deployed and production build uses REACT_APP_QZ_SIGNING_ENABLED=true, or allow materiahstock.com in QZ Site Manager.',
    };
  }
  if (
    message.includes('permission') ||
    message.includes('denied') ||
    message.includes('blocked')
  ) {
    return {
      code: 'QZ_PERMISSION',
      userMessage:
        'Materiah needs permission to communicate with QZ Tray on this computer.\n\nAllow “access apps and services on this device,” then try again.',
    };
  }
  logError(LOG_CONTEXT, 'unmapped QZ error', error);
  return {
    code: 'QZ_UNKNOWN',
    userMessage: 'Unable to connect to QZ Tray. Try again or use Print Preview.',
  };
};
